import { render, staticRenderFns } from "./ProductListItemSpecs.vue?vue&type=template&id=48906e42&scoped=true"
import script from "./ProductListItemSpecs.vue?vue&type=script&lang=js"
export * from "./ProductListItemSpecs.vue?vue&type=script&lang=js"
import style0 from "./ProductListItemSpecs.vue?vue&type=style&index=0&id=48906e42&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48906e42",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ColorTemperatureSwatch: require('/app/components/ColorTemperatureSwatch.vue').default})
